import { createApp } from 'vue'
import App from './App.vue'
import { AppRoute, router } from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './style/globalStyle.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'animate.css'
import '@/assets/iconfont/iconfont.css'
import 'wow.js/css/libs/animate.css'
import WOW from 'wow.js'
import {i18n} from './locale/Translate'
import '@wangeditor-next/editor/dist/css/style.css'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

AppRoute.instance.loadAsync().then(() => {
  const app = createApp(App)

  app.use(ElementPlus)

  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

  const wow = new WOW({
    boxClass: 'wow', // 类名，在用户滚动时显示隐藏的框。
    animateClass: 'animate__animated', // 触发CSS动画的类名称
    offset: 50, // 定义浏览器视口底部与隐藏框顶部之间的距离。当用户滚动并到达此距离时，隐藏的框会显示出来。
    mobile: true, // 在移动设备上打开/关闭WOW.js。
    live: true, // 在页面上同时检查新的WOW元素。
  })
  wow.init()

  app.use(router)
  app.use(i18n)
  app.mount("#app")
})
